import { LiveStreamCampaignStatus } from '@/shared/constants/auctions';
import {
  Auction as RemoteAuction,
  isAuctionLiveStreamEndingNow,
  isAuctionLiveStreamReady,
} from '@/shared/models/auction';

import { Auction } from './Row';

const AUCTION_MAIN_THUMBNAIL = 0;
const AUCTION_THUMBNAIL_COUNT = 3;

const getThumbImages = (auction: RemoteAuction): [string, string, string] => {
  const images = auction.promo_images
    .slice(1, 1 + AUCTION_THUMBNAIL_COUNT)
    .map((item) => item.medium);

  while (images.length < AUCTION_THUMBNAIL_COUNT) {
    images.push('');
  }

  return images as [string, string, string];
};

export const mapRemoteAuctionToCard = (auction: RemoteAuction): Auction => {
  const isLiveStream = isAuctionLiveStreamReady(auction);
  const isLiveStreamEndingNow = isAuctionLiveStreamEndingNow(auction);

  return {
    id: auction.id,
    href: auction.url,
    title: auction.title,
    curator: auction.auctioneers[AUCTION_MAIN_THUMBNAIL],
    mainImage: auction.promo_images[AUCTION_MAIN_THUMBNAIL]?.medium || '',
    thumbImages: getThumbImages(auction),
    numberOfLots: auction.lot_count,
    status: auction.status,
    startAt: auction.start_at,
    closeAt: new Date(auction.close_at).getTime(),
    liveStatus: auction.live_stream?.campaign_status as
      LiveStreamCampaignStatus | undefined,
    liveStartDate: auction.live_stream?.scheduled_start_at,
    isLiveStream,
    isLiveStreamEndingNow,
  };
};
